import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import "rsuite/dist/rsuite.min.css";
import Swal from "sweetalert2";
import DetailDialog from "./detailDialog";
import "react-confirm-alert/src/react-confirm-alert.css";
import { FaFileExport, FaEye, FaVoteYea, FaCheck } from "react-icons/fa";
import { Badge } from "@mui/material";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
function Stock() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  // const url = 'http://localhost:9000/api/'
  const api = apiInstance;

  const scroll = {
    height: "600px",
    overflowY: "scroll",
  };
  const [confirmList, setConfirmList] = useState([]);
  const [value, setValue] = useState("");
  const [open, setOpen] = useState(false);

  const [branchID, setBranchID] = useState("");

  const [hideMed, setHideMed] = useState(true);
  const [medUnitLists, setMedUnitLists] = useState([]);
  const [branchesLists, setBranchesLists] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  //Search
  const [searchLists, setSearchLists] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  //Branch
  const [brancheFilterLists, setBrancheFilterLists] = useState([]);
  const [showBranch, setShowBranch] = useState(false);

  //Date
  const [dateFilterLists, setDateFilterLists] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");

  //Excel Export
  const _export1 = React.useRef(null);
  const excelExport1 = () => {
    if (_export1.current !== null) {
      _export1.current.props.data.map(function (element, index) {
        element.code = element.code;
        element.date = element.createdAt?.split("T")[0];
        element.status = element.isConfirmed === true ? "Confirmed" : "Pending";
      });

      _export1.current.save();
    }
  };

  useEffect(() => {
    const getMedUnitLists = async () => {
      try {
        const res = await api.get("transfer-to-ho-requests");

        setMedUnitLists(res.data.data);
        console.log(res.data.data, "ori me list");
      } catch (err) {
        alert(err.message);
      }
    };
    const getReceivedLists = async () => {
      try {
        const res = await api.get("transfer-to-hos");

        // setMedUnitLists(res.data.data)
        setConfirmList(res.data.data);
        // console.log(res.data.data, 'rec list')
      } catch (err) {
        alert(err.message);
      }
    };

    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };

    const getConfirmList = async () => {
      try {
        const res = await api.get("transfer-to-hos");
        // setBranchesLists(res.data.list)
        // console.log(res.data.data, 'con')
      } catch (err) {
        alert(err.message);
      }
    };

    getBranches();
    getConfirmList();
    getReceivedLists();
    getMedUnitLists();
  }, []);

  //Search Filter
  const search = (event) => {
    console.log(event);
    if (event) {
      setSearchInput(event);
      setSearchLists(
        medUnitLists.filter((el) =>
          el?.code.toLowerCase().includes(event.toLowerCase()),
        ),
      );

      setShowSearch(true);
      setHideMed(false);
      setShowBranch(false);
    } else {
      setShowSearch(false);
      setHideMed(true);
      setShowBranch(false);
    }
  };

  //For Hide and Show related branch data
  const handleBranch = (event) => {
    setSearchInput("");
    setBranchID(event);
    const BranchID = branchesLists.filter((el) => el._id === event)[0]._id;
    setBrancheFilterLists(
      medUnitLists.filter((el) => el.relatedBranch._id === BranchID),
    );
    setShowBranch(true);
    setHideMed(false);
    setShowSearch(false);
  };

  //refresh function for callback
  const refreshData = async () => {
    try {
      const [medRes, receivedRes] = await Promise.all([
        api.get("transfer-to-ho-requests"),
        api.get("transfer-to-hos"),
      ]);
      setMedUnitLists(medRes.data.data);
      setConfirmList(receivedRes.data.data);
    } catch (err) {
      console.error("Error refreshing data:", err);
    }
  };

  //show detail view
  const handleDetail = (val) => {
    // console.log(val, 'imgPath')
    setValue(val);
    setOpen(true);
  };

  //confirm action
  const handleConfirm = (data) => {
    // console.log(data, 'data')
    const jsonData = {
      id: data._id,
      relatedBranch: data.relatedBranch._id,
    };

    api
      .post("items/issue-to-Ho/confirm", jsonData)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Created",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };

  //Filter Date
  const handleFilterDate = () => {
    setDateFilterLists(
      medUnitLists.filter(
        (el) =>
          el.createdAt?.split("T")[0] >= from &&
          (el.createdAt?.split("T")[0] <= to ||
            el.createdAt?.split("T")[0] < to),
      ),
    );

    setShowDate(true);
    setShowSearch(false);
    setShowBranch(false);

    setHideMed(false);
  };

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active ">
                      Receive Qty From POS
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row d-flex justify-content-between ">
                <div className="col-md-6">
                  {/* <h4>Medicine Item List</h4> */}
                </div>
                <div className="offset-1 col-md-4 ml-5">
                  <div
                    className="input-group row ml-5"
                    style={{ marginBottom: "20px" }}
                  ></div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row flex justify-content-between">
                        <div className="col-1 mt-2">
                          <button
                            type="button"
                            className="btn btn-sm btn-dark"
                            onClick={excelExport1}
                          >
                            <FaFileExport />
                            &nbsp; Export
                          </button>
                          &nbsp;
                        </div>
                        <div className="col-5">
                          <div className="row">
                            <div className="flex form-group col-5">
                              <input
                                type="date"
                                name="from"
                                id="from"
                                onChange={(e) => setFrom(e.target.value)}
                                className="form-control"
                              />
                            </div>
                            <div className="form-group col-5">
                              <input
                                type="date"
                                name="to"
                                id="to"
                                onChange={(e) => setTo(e.target.value)}
                                className="form-control"
                              />
                            </div>
                            <div className="form-group col-2">
                              <button
                                className="btn btn-sm btn-primary"
                                style={{ marginTop: "10px" }}
                                onClick={handleFilterDate}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-2">
                          <input
                            type="text"
                            className="form-control rounded "
                            style={{ borderRadius: "17px" }}
                            name="input"
                            onChange={(e) => search(e.target.value)}
                            id="search_code"
                            placeholder="Search Items"
                          />
                        </div>
                        <div className="col-2" style={{ marginTop: "0.1rem" }}>
                          <div className="form-group">
                            <select
                              name="currency"
                              id=""
                              className="form-control mt-1"
                              onchange="convert(this.value)"
                              // placeholder='Filter By Branches'
                              onChange={(e) => {
                                handleBranch(e.target.value);
                              }}
                            >
                              <option hidden>Filter By Branches</option>

                              {branchesLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-body">
                      {/* Export data in Excel */}
                      {/* For Procedure Medicine Items */}
                      <ExcelExport
                        data={
                          (hideMed && medUnitLists) ||
                          (showSearch && searchLists) ||
                          (showBranch && brancheFilterLists) ||
                          (showDate && dateFilterLists)
                        }
                        ref={_export1}
                      >
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="date"
                          title="Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field="code"
                          title="Code"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="relatedBranch.name"
                          title="Branch"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="reason"
                          title="Description"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field="status"
                          title="Status"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />
                      </ExcelExport>
                      {/* End        */}

                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="" style={{ scroll }}>
                            <table className="table">
                              <thead
                                className="sticky-top bg-light"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                              >
                                <tr>
                                  <th style={{ fontWeight: "400px" }}>#</th>
                                  <th style={{ fontWeight: "400px" }}>
                                    Created Date
                                  </th>
                                  <th style={{ fontWeight: "400px" }}>Code</th>
                                  <th>Branch</th>
                                  <th>Desc</th>
                                  <th>Status</th>
                                  <th
                                    className="text-center"
                                    style={{ fontWeight: "400px" }}
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody id="table_body">
                                {showSearch &&
                                  searchLists.map((item, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{item.createdAt?.split("T")[0]}</td>
                                      <td>{item?.code}</td>
                                      <td>
                                        {item.relatedBranch
                                          ? item.relatedBranch.name
                                          : "-"}
                                      </td>

                                      <td>{item?.reason}</td>
                                      <td>
                                        {item.isConfirmed === true ? (
                                          <Badge color="success">
                                            Confirmed &nbsp;
                                            <FaCheck />
                                          </Badge>
                                        ) : (
                                          <Badge color="warning">
                                            Pending&nbsp;- - -
                                          </Badge>
                                        )}
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{ width: "140px  " }}
                                      >
                                        {/* {item.isConfirmed === true ? (
                                          <span className="btn btn-sm btn-outline-secondary disabled">
                                            <FaVoteYea />
                                          </span>
                                        ) : (
                                          <span
                                            onClick={() => handleConfirm(item)}
                                            className="btn btn-sm btn-outline-primary"
                                          >
                                            <FaVoteYea />
                                          </span>
                                        )} */}

                                        <span
                                          onClick={() => handleDetail(item)}
                                          className=" btn btn-sm btn-outline-dark ml-2"
                                        >
                                          <abbr title="Detail">
                                            <FaEye />
                                          </abbr>
                                        </span>
                                      </td>
                                    </tr>
                                  ))}

                                {hideMed &&
                                  medUnitLists.map((item, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{item.createdAt?.split("T")[0]}</td>
                                      <td>{item?.code}</td>
                                      <td>
                                        {item.relatedBranch
                                          ? item.relatedBranch.name
                                          : "-"}
                                      </td>

                                      <td>{item?.reason}</td>
                                      <td>
                                        {item.isConfirmed === true ? (
                                          <Badge color="success">
                                            Confirmed &nbsp;
                                            <FaCheck />
                                          </Badge>
                                        ) : (
                                          <Badge color="warning">
                                            Pending&nbsp;- - -
                                          </Badge>
                                        )}
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{ width: "140px  " }}
                                      >
                                        {/* {item.isConfirmed === true ? (
                                          <span className="btn btn-sm btn-outline-secondary disabled">
                                            <FaVoteYea />
                                          </span>
                                        ) : (
                                          <span
                                            onClick={() => handleConfirm(item)}
                                            className="btn btn-sm btn-outline-primary"
                                          >
                                            <FaVoteYea />
                                          </span>
                                        )} */}

                                        <span
                                          onClick={() => handleDetail(item)}
                                          className=" btn btn-sm btn-outline-dark ml-2"
                                        >
                                          <abbr title="Detail">
                                            <FaEye />
                                          </abbr>
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                {showBranch &&
                                  brancheFilterLists.map((item, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{item.createdAt?.split("T")[0]}</td>
                                      <td>{item?.code}</td>
                                      <td>
                                        {item.relatedBranch
                                          ? item.relatedBranch.name
                                          : "-"}
                                      </td>

                                      <td>{item?.reason}</td>
                                      <td>
                                        {item.isConfirmed === true ? (
                                          <Badge color="success">
                                            Confirmed &nbsp;
                                            <FaCheck />
                                          </Badge>
                                        ) : (
                                          <Badge color="warning">
                                            Pending&nbsp;- - -
                                          </Badge>
                                        )}
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{ width: "140px  " }}
                                      >
                                        {/* {item.isConfirmed === true ? (
                                          <span className="btn btn-sm btn-outline-secondary disabled">
                                            <FaVoteYea />
                                          </span>
                                        ) : (
                                          <span
                                            onClick={() => handleConfirm(item)}
                                            className="btn btn-sm btn-outline-primary"
                                          >
                                            <FaVoteYea />
                                          </span>
                                        )} */}

                                        <span
                                          onClick={() => handleDetail(item)}
                                          className=" btn btn-sm btn-outline-dark ml-2"
                                        >
                                          <abbr title="Detail">
                                            <FaEye />
                                          </abbr>
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                {showDate &&
                                  dateFilterLists.map((item, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{item.createdAt?.split("T")[0]}</td>
                                      <td>{item?.code}</td>
                                      <td>
                                        {item.relatedBranch
                                          ? item.relatedBranch.name
                                          : "-"}
                                      </td>

                                      <td>{item?.reason}</td>
                                      <td>
                                        {item.isConfirmed === true ? (
                                          <Badge color="success">
                                            Confirmed &nbsp;
                                            <FaCheck />
                                          </Badge>
                                        ) : (
                                          <Badge color="warning">
                                            Pending&nbsp;- - -
                                          </Badge>
                                        )}
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{ width: "140px  " }}
                                      >
                                        {item.isConfirmed === true ? (
                                          <span className="btn btn-sm btn-outline-secondary disabled">
                                            <FaVoteYea />
                                          </span>
                                        ) : (
                                          <span
                                            onClick={() => handleConfirm(item)}
                                            className="btn btn-sm btn-outline-primary"
                                          >
                                            <FaVoteYea />
                                          </span>
                                        )}

                                        <span
                                          onClick={() => handleDetail(item)}
                                          className=" btn btn-sm btn-outline-dark ml-2"
                                        >
                                          <abbr title="Detail">
                                            <FaEye />
                                          </abbr>
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <DetailDialog
                open={open}
                close={() => setOpen(false)}
                data={value}
                onRefresh={refreshData}
              />
            </div>
          </section>
        </div>

    </>
  );
}
export default Stock;
